export default __webpack_public_path__ + "static/media/utl_logo.8f233bcc.png";